import { $win, $doc, getCurrentDevice, keys, manualUpdate, isValidDate } from './utils';
import { eqRows, initManualFormat } from './bm-utils';
import moment from 'moment';
import Pikaday from 'pikaday';

const $bm = $('.bm');
const format = 'MM/DD/YYYY';
const formatText = 'ddd, MMMM D';
const formatTextShort = 'M/D';
const $filterText = $('.js-filters-dates-text');

moment.locale($('html').attr('lang'));

const initDatepickers = () => {
	const $datepickers = $('.js-modal-datepickers');

	$datepickers.each((index, el) => {
		const container = el.querySelector('.js-modal-datepicker-container');
		const fieldStart = el.querySelector('.js-modal-start');
		const fieldEnd = el.querySelector('.js-modal-end');
		const textDates = document.querySelectorAll('.js-filters-number-dates');
		const minDate = $(fieldStart).data('before') ? false : new Date();
		let numberOfMonths = 2;

		let startDate, endDate;

		const today = moment(new Date()).format(format);
		const tomorrow = moment(today).add('1', 'day').format(format);

		// Select whole input text on click
		$(fieldStart).add(fieldEnd).on('click', function() {
			this.setSelectionRange(0, this.value.length);
		});

		if ( getCurrentDevice() == 'mobile' ) {
			numberOfMonths = 1;
		}

		const options = {
			minDate,
			container,
			keyboardInput: false,
			bound: false,
			format,
			numberOfMonths: numberOfMonths,
			theme: 'pikaday-bm',
			i18n: {
				months        : moment.months(),
				weekdays      : moment.weekdays(),
				weekdaysShort : moment.weekdaysShort()
			}
		}

		const updateStartDate = () => {
			startPicker.setStartRange(startDate);
			endPicker.setStartRange(startDate);
			endDate = moment(startDate).add('1','day')._d;
			endPicker.setMinDate(endDate);
			endPicker.setDate(endDate);
			startPicker.setEndRange(endDate);

			startPicker.hide();
			endPicker.show();
		}

		const updateEndDate = () => {
			startPicker.setEndRange(endDate);
			endPicker.setEndRange(endDate);

			endPicker.hide();
			startPicker.show();
		}

		const startPicker = new Pikaday({
			field: fieldStart,
			...options,
			onSelect: function() {
				startDate = this.getDate();
				updateStartDate();

				setTimeout(function() {
					const nextDate = moment(startDate).add(1, 'days');
					const selectedMonth = nextDate.month();
					const selectedYear = nextDate.year();

					$(fieldEnd).val(nextDate.format(format));

					const date = moment(startDate).add(1, 'days');
					let currentMonth = nextDate.month();
					let currentYear = nextDate.year();

					if ( startPicker.calendars[1].month == currentMonth ) {
						currentMonth = startPicker.calendars[0].month;
						currentYear = startPicker.calendars[0].year;
					}

					endPicker.gotoMonth(currentMonth);
					endPicker.gotoYear(currentYear);

					$(fieldEnd).focus();

					updateFiltrationText();
				}, 10);

				$('.js-clear-datepicker').removeClass('disable');
			},
			onDraw: function() {
				eqRows(container);
			}
		});

		const endPicker = new Pikaday({
			field: fieldEnd,
			...options,
			onSelect: function() {
				endDate = this.getDate();
				updateEndDate();

				updateFiltrationText();
				
				$('.js-clear-datepicker').removeClass('disable');
			},
			onDraw: function() {
				eqRows(container);
			}
		});

		startPicker.show();
		endPicker.hide();

		const _startDate = startPicker.getDate();
		const _endDate = endPicker.getDate();

		if (_startDate) {
			startDate = _startDate;
			updateStartDate();
		}
		if (_endDate) {
			endDate = _endDate;
			updateEndDate();
		}

		$(fieldStart).on('focusout', function() {
			updateStartDate();
		});

		$(fieldEnd).on('focusout', function() {
			updateEndDate();
		});

		$(fieldStart).on('keyup', e => {
			if (e.keyCode === keys.enter) {
				updateStartDate();
			}
		});

		$(fieldEnd).on('keyup', e => {
			if (e.keyCode === keys.enter) {
				updateEndDate();
			}
		});

		$(fieldStart).on('change', function() {
			if ( manualUpdate ) {
				startDate = moment($(this).val(), format).set({year: moment().format('YYYY')})._d;
				updateStartDate();

				const nextDate = moment(startDate).add(1, 'days');
				const selectedMonth = nextDate.month();
				const selectedYear = nextDate.year();

				endPicker.setEndRange(nextDate._d);

				endPicker.gotoMonth(selectedMonth);
				endPicker.gotoYear(selectedYear);
			}
		});

		$(fieldEnd).on('change', function() {
			if ( manualUpdate ) {
				const val = $(this).val();

				endDate = moment(val, format).set({year: moment(val, format).format('YYYY')})._d;
				updateEndDate();
			}
		});

		$('.modal-filter').on('show.bs.modal', e => {
			endPicker.hide();
			startPicker.show();
		});

		const updateFiltrationText = () => {
			const start = moment(fieldStart.value).format(formatTextShort);
			const end = moment(fieldEnd.value).format(formatTextShort);

			$filterText.text(`(${start}-${end})`);

			if (moment(start).isValid() && moment(end).isValid()) {
				$filterText.closest('.filter, .filter-mobile').addClass('activated');
			}
		}

		$('.modal-filter').on('hide.bs.modal', e => {
			updateFiltrationText();
		});

		initManualFormat(fieldStart);
		initManualFormat(fieldEnd);

		$('.js-clear-datepicker').on('click', function() {
			startPicker.setDate(null);
			endPicker.setDate(null);
			startPicker.destroy();
			endPicker.destroy();

			$filterText.text('');
			$filterText.closest('.filter').removeClass('activated');
			$filterText.closest('.filter-mobile').removeClass('activated');

			$('.js-clear-datepicker').off('click');

			initDatepickers();

			$('.js-clear-datepicker:not([type="reset"])').addClass('disable');
		})
	});
}

export default function bmUI() {
	initDatepickers();
}
